import React from 'react';
import { LayoutHOC } from '../../../base/ui/layout/layout';
import { workOrderFinished } from './WorkOrderFinished';

export const createWorkOrderFinishedPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(workOrderFinished());
};
